export const cardGridGap = 30;

export const scrollbarWidth = "(100vw - 100%)";
